import { useState, useEffect, useRef } from "react";
// npm install bootstrap-icons してから↓をmain.tsxかここに追加
// import "bootstrap-icons/font/bootstrap-icons.css";
// もしくは index.html に CDN を追加:
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css">

type Line =
  | { kind: "text";  color: string; text: string }
  | { kind: "entry"; color: string; text: string; comment?: string }
  | { kind: "empty" };

const LINES: Line[] = [
  { kind: "text",  color: "text-green-400", text: "[INFO] Loading profile..." },
  { kind: "text",  color: "text-green-400", text: "[OK]   Profile loaded successfully." },
  { kind: "text",  color: "text-zinc-700",  text: "────────────────────────────" },
  { kind: "text",  color: "text-zinc-500",  text: "# 基本情報" },
  { kind: "entry", color: "text-sky-300",   text: 'name:     "くりもご"' },
  { kind: "entry", color: "text-sky-300",   text: 'birthday: "6月6日"' },
  { kind: "entry", color: "text-sky-300",   text: 'age:      "18"' },
  { kind: "empty" },
  { kind: "text",  color: "text-zinc-500",  text: "# 使ったことある技術" },
  { kind: "text",  color: "text-zinc-400",  text: "languages:" },
  { kind: "entry", color: "text-sky-300",   text: "  - TypeScript",      comment: "メインで使ってる" },
  { kind: "entry", color: "text-sky-300",   text: "  - React",           comment: "フロントはほぼこれ" },
  { kind: "entry", color: "text-sky-300",   text: "  - Python",          comment: "ちょっとだけ" },
  { kind: "entry", color: "text-sky-300",   text: "  - Rust",            comment: "所有権と戦い中..." },
  { kind: "empty" },
  { kind: "text",  color: "text-zinc-500",  text: "# 趣味" },
  { kind: "text",  color: "text-zinc-400",  text: "hobbies:" },
  { kind: "entry", color: "text-sky-300",   text: "  - 釣り",            comment: "内房でシロギス釣り" },
  { kind: "entry", color: "text-sky-300",   text: "  - レーシングカート", comment: "けっこう本気" },
  { kind: "entry", color: "text-sky-300",   text: "  - ゲーム",          comment: "全ジャンル広く浅く" },
  { kind: "empty" },
  { kind: "text",  color: "text-zinc-500",  text: "# 好きなもの" },
  { kind: "text",  color: "text-zinc-400",  text: "loves:" },
  { kind: "entry", color: "text-sky-300",   text: "  - ゴツい機械全般",  comment: "ボタンとノブがたくさんあるやつ" },
  { kind: "empty" },
  { kind: "text",  color: "text-zinc-500",  text: "# Favorite Music" },
  { kind: "text",  color: "text-zinc-400",  text: "favorite_songs:" },
  { kind: "entry", color: "text-sky-300",   text: "  - 2000s J-pop",     comment: "ZARDとか、あの時代の空気感" },
  { kind: "empty" },
  { kind: "text",  color: "text-zinc-500",  text: "# 一言" },
  { kind: "entry", color: "text-amber-300", text: 'motto: "全身全霊、自分というアルゴリズムで生き続ける"' },
  { kind: "text",  color: "text-zinc-700",  text: "────────────────────────────" },
];

// 技術スタック（過剰）
const STACK = [
  { name: "TypeScript", level: 3, color: "bg-blue-100 text-blue-800 border-blue-200",    icon: "bi-filetype-tsx", note: "毎日使ってる" },
  { name: "React",      level: 3, color: "bg-cyan-100 text-cyan-800 border-cyan-200",     icon: "bi-grid-1x2",    note: "これがないと生きられない" },
  { name: "Vite",       level: 3, color: "bg-purple-100 text-purple-800 border-purple-200", icon: "bi-lightning-charge", note: "爆速" },
  { name: "Tailwind",   level: 2, color: "bg-sky-100 text-sky-800 border-sky-200",        icon: "bi-paint-bucket", note: "CSSもう書けない体になった" },
  { name: "Python",     level: 2, color: "bg-yellow-100 text-yellow-800 border-yellow-200", icon: "bi-filetype-py", note: "ちょっとだけ" },
  { name: "Rust",       level: 1, color: "bg-orange-100 text-orange-800 border-orange-200", icon: "bi-cpu",        note: "所有権????" },
  { name: "Git",        level: 3, color: "bg-red-100 text-red-800 border-red-200",         icon: "bi-git",        note: "コミットしまくってる" },
  { name: "GitHub",     level: 3, color: "bg-zinc-100 text-zinc-800 border-zinc-200",      icon: "bi-github",     note: "草を生やす場所" },
  { name: "Node.js",    level: 2, color: "bg-green-100 text-green-800 border-green-200",   icon: "bi-box",        note: "package.jsonだらけ" },
  { name: "VSCode",     level: 3, color: "bg-indigo-100 text-indigo-800 border-indigo-200", icon: "bi-code-square", note: "拡張100個入ってる" },
  { name: "Linux",      level: 1, color: "bg-stone-100 text-stone-800 border-stone-200",   icon: "bi-terminal",   note: "なんとなく使える" },
  { name: "SQL",        level: 1, color: "bg-teal-100 text-teal-800 border-teal-200",      icon: "bi-database",   note: "SELECTくらいなら" },
];

const LINKS = [
  { label: "GitHub",   icon: "bi-github",        href: "https://github.com/kurimogo",      color: "hover:text-zinc-900" },
  { label: "X",        icon: "bi-twitter-x",     href: "https://x.com/kurimogo",           color: "hover:text-zinc-900" },
  { label: "Qita",     icon: "bi-book",          href: "https://qiita.com/kurimogo",         color: "hover:text-blue-500" },
  { label: "Email",    icon: "bi-envelope",      href: "mailto:kurimogo@email.com",          color: "hover:text-red-500" },
];

const PROJECTS = [
  {
    title: "Concordia",
    description: "年齢関係なく計算能力が鍛えられるミニゲーム",
    link: "https://concordia.kurimogo.dev",
    tags: ["計算力", "学習", "SPA"],
  },
  {
    title: "今後追加予定",
    description: "ここに新しい制作物を追加していけます。",
    link: "#projects",
    tags: ["coming soon"],
  },
];

function LevelDots({ level }: { level: number }) {
  return (
    <span className="flex gap-0.5 items-center ml-1">
      {[1, 2, 3].map((n) => (
        <span
          key={n}
          className={`inline-block w-1.5 h-1.5 rounded-full ${n <= level ? "bg-current opacity-70" : "bg-current opacity-20"}`}
        />
      ))}
    </span>
  );
}

function Cursor() {
  return (
    <span className="inline-block w-[7px] h-[13px] bg-blue-400 align-middle ml-0.5 animate-[blink_1s_step-end_infinite]" />
  );
}

function TerminalLine({ line }: { line: Line }) {
  if (line.kind === "empty") return <div className="h-[0.5lh]">&nbsp;</div>;
  if (line.kind === "entry" && line.comment) {
    return (
      <div className="flex flex-wrap gap-x-2">
        <span className={`${line.color} whitespace-pre`}>{line.text}</span>
        <span className="text-zinc-600 whitespace-nowrap">// {line.comment}</span>
      </div>
    );
  }
  return (
    <div className={`${line.color} whitespace-pre-wrap break-all`}>
      {line.text || "\u00a0"}
    </div>
  );
}

function TerminalIntro() {
  const [started, setStarted]      = useState(false);
  const [visibleLines, setVisible] = useState(0);
  const bottomRef                  = useRef<HTMLDivElement>(null);

  function start() { if (!started) setStarted(true); }

  useEffect(() => {
    const h = (e: KeyboardEvent) => { if (e.key === "Enter") start(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [started]);

  useEffect(() => {
    if (!started || visibleLines >= LINES.length) return;
    const delay = visibleLines < 2 ? 220 : 60;
    const t = setTimeout(() => setVisible((v) => v + 1), delay);
    return () => clearTimeout(t);
  }, [started, visibleLines]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [visibleLines]);

  const done = visibleLines >= LINES.length;

  return (
    <div className="bg-[#0d1117] rounded-xl overflow-hidden w-full">
      <div className="bg-[#21262d] px-4 py-2.5 flex items-center gap-2">
        <span className="w-3 h-3 rounded-full bg-[#ff5f56] shrink-0" />
        <span className="w-3 h-3 rounded-full bg-[#ffbd2e] shrink-0" />
        <span className="w-3 h-3 rounded-full bg-[#27c93f] shrink-0" />
        <span className="ml-2 text-[11px] sm:text-xs text-zinc-500 font-mono truncate">portfolio — bash</span>
      </div>
      <div className="px-4 sm:px-6 pt-4 pb-5 font-mono text-[11px] sm:text-[13px] leading-[1.75]">
        <div className="flex items-center flex-wrap gap-x-0">
          <span className="text-green-400">kurimogo@dev</span>
          <span className="text-zinc-300">:</span>
          <span className="text-blue-400">~</span>
          <span className="text-zinc-300 mr-1">$</span>
          <span className="text-zinc-100">./intro.sh</span>
          {!started && <Cursor />}
        </div>
        {!started && (
          <div className="mt-3">
            <button
              onClick={start}
              className="border border-zinc-700 text-blue-400 text-[11px] sm:text-xs font-mono px-4 py-1.5 rounded-md hover:bg-blue-950 hover:border-blue-400 transition-colors cursor-pointer bg-transparent"
            >
              ▶ Enter / Run
            </button>
            <p className="text-[10px] sm:text-[11px] text-zinc-600 mt-1.5">クリックまたはEnterキーで実行</p>
          </div>
        )}
        {started && LINES.slice(0, visibleLines).map((line, i) => (
          <TerminalLine key={i} line={line} />
        ))}
        {done && (
          <div className="flex items-center mt-0.5">
            <span className="text-green-400">kurimogo@dev</span>
            <span className="text-zinc-300">:</span>
            <span className="text-blue-400">~</span>
            <span className="text-zinc-300 mr-1">$</span>
            <Cursor />
          </div>
        )}
        <div ref={bottomRef} />
      </div>
    </div>
  );
}

function TechStack() {
  return (
    <div className="flex flex-wrap gap-2">
      {STACK.map((tech) => (
        <div
          key={tech.name}
          title={tech.note}
          className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-xs font-medium cursor-default select-none transition-transform hover:scale-105 ${tech.color}`}
        >
          <i className={`bi ${tech.icon} text-sm`} />
          <span>{tech.name}</span>
          <LevelDots level={tech.level} />
        </div>
      ))}
    </div>
  );
}

export default function App() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-5 py-8 text-zinc-800">
      <header className="text-center mb-10 sm:mb-12">
        <h1 className="text-3xl sm:text-4xl font-bold m-0">kurimogoのポートフォリオ</h1>
        <p className="text-zinc-500 mt-2 text-sm sm:text-base">Web Developer / Student</p>
      </header>

      <section className="mb-10 sm:mb-12">
        <h2 className="text-xl sm:text-2xl font-semibold mb-4">About Me</h2>
        <TerminalIntro />
      </section>

      <section className="mb-10 sm:mb-12">
        <h2 className="text-xl sm:text-2xl font-semibold mb-1">Tech Stack</h2>
        <p className="text-xs text-zinc-400 mb-4">
          ● ● ● = 使いこなしてる　● ● ○ = まあまあ　● ○ ○ = かじった程度　ホバーで一言
        </p>
        <TechStack />
      </section>

      <section className="mb-10 sm:mb-12" id="projects">
        <h2 className="text-xl sm:text-2xl font-semibold mb-4">制作物</h2>
        <p className="text-sm text-zinc-500 mb-5">今後も随時追加する予定です。まずは最新の作品を紹介します。</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {PROJECTS.map((project) => (
            <a
              key={project.title}
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-5 rounded-3xl border border-zinc-200 bg-white shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex items-center justify-between gap-3">
                <div>
                  <h3 className="text-lg font-semibold mb-2">{project.title}</h3>
                  <p className="text-zinc-600 text-sm leading-relaxed">{project.description}</p>
                </div>
                <span className="inline-flex items-center justify-center w-9 h-9 rounded-2xl bg-blue-50 text-blue-700 text-sm font-bold">Go</span>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {project.tags.map((tag) => (
                  <span key={tag} className="text-[11px] uppercase tracking-[0.12em] bg-zinc-100 text-zinc-600 px-2.5 py-1 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            </a>
          ))}
        </div>
      </section>

      <section className="mb-10 sm:mb-12">
        <h2 className="text-xl sm:text-2xl font-semibold mb-4">Contact</h2>
        <div className="flex flex-wrap gap-3">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center gap-2 px-4 py-2 rounded-xl border border-zinc-200 text-zinc-500 text-sm font-medium no-underline transition-colors ${l.color}`}
            >
              <i className={`bi ${l.icon} text-base`} />
              {l.label}
            </a>
          ))}
        </div>
      </section>

      <footer className="text-center text-zinc-400 mt-10 sm:mt-12 text-sm">
        <p>© 2026 Kurimogo</p>
      </footer>
    </div>
  );
}
